import { AVAILABLE_MARKETS } from '$lib/services/market/constants';
import type { ParamMatcher } from '@sveltejs/kit';

export const match: ParamMatcher = (value: string) => {
    return Boolean(Object.values(AVAILABLE_MARKETS).find((market) => market.slug === value));
};
